<nav class="mb-6 flex items-center gap-1 border-b border-slate-200" aria-label="Onglets">
  @for (tab of items(); track tab.route) {
    <a
      [attr.data-testid]="'tab-' + tab.route"
      [routerLink]="tab.route"
      routerLinkActive="is-active"
      #rla="routerLinkActive"
      [attr.aria-current]="rla.isActive ? 'page' : null"
      class="tab-btn flex cursor-pointer items-center gap-2 px-4 py-3 text-sm font-medium no-underline">
      @if (tab.icon) {
        <elcia-icon [iconType]="tab.icon" [iconSize]="'md'"/>
      }
      <span>{{ tab.label | translate }}</span>
      @if (tab.hasPendingChanges) {
        <elcia-dot [attr.aria-label]="'app.unsaved-changes' | translate" [color]="'#fbbf24'"/>
      }
    </a>
  }
</nav>
